import ReactDOM from 'react-dom/client';
import App from './App';
import { createBrowserHistory } from 'history';
import { CustomRouter, ThemeProvider } from 'components/features';
import './index.css';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

export const browserHistory = createBrowserHistory();

root.render(
  // <React.StrictMode>
  <CustomRouter history={browserHistory}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </CustomRouter>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
